/* eslint-disable @typescript-eslint/no-redeclare */
import { BusinessInvite } from '../services/model/inviteService.model';
import { Features } from '../utils/FeatureUtils';
import { SubscriptionType } from './misc';

export type Subscription = {
  subscriptionType: SubscriptionType;
  endDate: Date | string;
  willRenew: boolean;
};

export default interface Business {
  businessId?: number;
  role: AdminRole;
  inviteId: string | null;
  picture: string | null;
  name: string;
  description: string;
  type: BusinessType;
  inviteFields?: BusinessInvite;
  communityId?: number;
  subscription?: Subscription;
  trialType?: SubscriptionType;
  trialEndDate?: string | Date;
  dashboardEnabled: boolean;
  features?: Features;
  memberPreferences?: MemberPreferences;
}

export enum CommunityType {
  ROOMMATES = 'ROOMMATES',
  STUDENTGROUP = 'STUDENTGROUP',
  SPORTTEAM = 'SPORTTEAM',
  ASSOCIATION = 'ASSOCIATION',
  COLLEAGUES = 'COLLEAGUES',
  FAMILY = 'FAMILY',
  FRIENDS = 'FRIENDS',
  OTHER_COMMUNITY = 'OTHER_COMMUNITY',
}

export enum MomentType {
  WEDDING = 'WEDDING',
  BIRTH = 'BIRTH',
  FUNERAL = 'FUNERAL',
  OTHER_MOMENT = 'OTHER_MOMENT',
}

export const BusinessType = {
  ...CommunityType,
  ...MomentType,
};

export type BusinessType = CommunityType | MomentType;

export enum AdminRole {
  OWNER = 'OWNER',
  MEMBER = 'MEMBER',
}

export interface Admin {
  adminId?: number;
  userId?: number;
  role: AdminRole;
  display: string;
  picture?: string;
  pending?: boolean;
  inviteId?: number;
  onboarding?: boolean;
}

/**
 * Model AdminInvite
 *
 */
export type AdminInvite = {
  inviteId: number;
  userId?: number;
  display: string;
  picture?: string;
  role: AdminRole;
};

export type MemberPreferences = {
  [CATEGORY in 'EVENTS' | 'MEMBERS' | 'STATS_AND_SCORES' | 'TASKS' | 'PHOTO_ALBUMS' | 'COST_SPLITTING']?: {
    [OPERATION in 'CREATE' | 'UPDATE' | 'DELETE']?: boolean;
  };
};
